<template>
	<div class="container-fluid pos-r" data-config-step="4">
		<general-modal />
		<pos-mode-modal />
		<!-- step-4-config -->
		<div class="row desktop-config">
			<div class="config-container pos-r">
				<!-- config-navbar-with-checkout -->
				<config-navbar />
				<!-- /.config-navbar-with-checkout -->
				<div class="pc-config col-xs-12">
					<!-- pc-config -->
					<div class="config-details">
						<!-- selected-games -->
						<games-info class="fps-graphing m-b" />
						<!-- /.selected-games -->
						<div class="build-render">
							<!-- img-explode -->
							<pc-render :active-build="activeBuild" :session-data="sessionData"/>
							<compatibility-icons/>
							<!-- /.img-explode -->
						</div>
					</div>
					<!-- /.pc-config -->
					<!-- pc-config-tabs-content -->
					<products-tabs :session-data="sessionData"/>
					<!-- pc-config-tabs-content -->
					<!-- CONFIG TABS ARE DEVIDED IN TWOS -->
					<!-- pc-config-tabs -->
					<tabs-menu v-if="!showLoadingOverlay"/>
					<!-- /.pc-config-tabs -->
				</div>
				<div class="clearfix"/>
			</div>
		</div>
		<!-- /.step-4-config -->
		<!-- modals -->
		<div id="share-overlay" class="modal fade in">
			<div role="document" class="modal-dialog modal-sm">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							class="close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												USE THE LINK BELOW TO SHARE YOUR BUILD
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>{{ fullPath }}</a>
											<button
												id="copy-to-clip"
												data-clipboard-target="#clip"
												class="btn btn-green btn-block btn-outline m-y"
												@click="copyToClipboard('#clip')"
											>
												Click to copy
											</button>
										</div>
										<social-share-links />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="share-mail" class="modal fade in">
			<div role="document" class="modal-dialog modal-sm">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							class="close"
							title="Close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												Enter your email amd we will send you the build!
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>{{ fullPath }}</a>
											<div v-if="!emailSent" class="form-group field m-t">
												<input
													v-model="email"
													autofocus
													placeholder="EMAIL"
													type="email"
													class="form-control"
													name="share_email"
													required
													data-vv-as="Email"
													v-validate="'required|email'"
												>
												<span v-show="errors.has('share_email')" class="text-danger text-left">
													{{ errors.first('share_email') }}
												</span>
											</div>
											<button v-if="!emailSent" class="btn btn-green btn-block btn-outline m-y" @click="sendBuildToEmail()">SEND</button>
											<button v-if="emailSent" class="btn btn-green btn-block btn-outline m-y" @click="emailSent = false, email = ''">SENT</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div id="save-bld" class="modal fade">
			<div role="document" class="modal-dialog modal-sm">
				<div class="modal-content text-center">
					<div class="modal-header text-center">
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							class="close"
						>
							<span aria-hidden="true">×</span>
						</button>
					</div>
					<div class="modal-header m-a-0">
						<h2 class="text-center text-white m-a-0">SHARE YOUR BUILD</h2>
					</div>
					<div class="modal-body">
						<div class="text-center">
							<div class="panel-user">
								<div class="row">
									<div class="col-md-12">
										<div class="text text-grey m-t">
											<p>
												CLICK THE LINK BELOW TO SHARE
											</p>
										</div>
										<div class="link m-b">
											<a
												id="clip"
												:href="fullPath"
												target="_blank"
												class="m-y"
											>{{ fullPath }}</a>
											<h4 class="text-center text-white m-y">OR</h4>
											<router-link :to="{ path: '/user/account?currentTab=saved-build' }">SEE ALL YOUR SAVED BUILDS</router-link>
											<div class="breadcrumb-build">BUILDS &gt; Saved</div>
										</div>
										<social-share-links />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			id="vr-modal"
			tabindex="-1"
			role="dialog"
			class="modal fade in"
		>
			<div role="document" class="modal-dialog modal-sm">
				<div class="modal-content">
					<div class="modal-header text-center">
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							class="close"
						>
							<span aria-hidden="true">×</span>
						</button>
						<h2 class="text-white">Your build is VR Ready!</h2>
					</div>
					<div class="modal-body text-white">
						<p class="text-center">
							This means your PC meets the minimum recommended specs to play games on the Oculus Rift,
							HTC VIVE and other VR devices.
						</p>
					</div>
				</div>
			</div>
		</div>
		<rules-handler :session-data="sessionData"/>
		<div
			id="parts-details-modal"
			class="modal fade in"
			tabindex="-1"
			role="dialog"
		>
			<partdetails-modal v-if="partDetails.show" :id="partDetails.id" :variant-id="partDetails.variantId"/>
		</div>
		<div
			v-if="showLoadingOverlay"
			id="general-overlay"
			class="overlay"
			style="display:block;"
		/>
		<div v-if="showLoadingOverlay" class="loading">
			<p>{{ loadingText }}</p>
		</div>
		<!-- /.modals -->
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { Validator } from "vee-validate";
import ConfiguratorMixin from "@m/configurator";
import PcRender from "./components/pc-render/pc-render.vue";
import ConfigNavbar from "./components/config-navbar/config-navbar.vue";
import GamesInfo from "./components/games-info/games-info.vue";
import CompatibilityIcons from "./components/compatibility-icons/compatibility-icons.vue";
import ProductsTabs from "./components/products-tabs/products-tabs.vue";
import TabsMenu from "./components/tabs-menu/tabs-menu.vue";
import RulesHandler from "./components/rules-handler/rules-handler.vue";
import partdetailsModal from "../part-details-modal.vue";
import socialShareLinks from "./social-share-links";
import PosModeModal from "../pos-mode-modal";

export default {
	name: "Step4",
	components: {
		PcRender,
		ConfigNavbar,
		CompatibilityIcons,
		GamesInfo,
		ProductsTabs,
		TabsMenu,
		RulesHandler,
		partdetailsModal,
		socialShareLinks,
		PosModeModal
	},
	mixins: [
		ConfiguratorMixin
	],
	data() {
		return {
			email: "",
			emailSent: false,
			fullPath: window.location.href
		};
	},
	computed: {
		...mapGetters(["isLoading", "partDetails", "loadingText"]),
		...mapState({
			activeBuild: state => state.Step4.activeBuild,
			games: state => state.Step4.sessionGamesData,
			sessionData: state => state.Step4.sessionData,
			showLoadingOverlay: state => state.Step4.showLoadingOverlay
		})
	},
	watch: {
		activeBuild: {
			handler() {
				if (window.localStorage.getItem("session-draft")) {
					if (this.draftId == window.localStorage.getItem("session-draft")) {
						this.setLocalStorageVuex();
						this.updateBuildInDatabase();
					}
				}
			},
			deep: true
		},
		"activeBuild.cpu"(current, previous) {
			if (previous && current.products_id != previous.products_id) {
				this.getGamesFPS();
			}
		},
		"activeBuild.gpu"(current, previous) {
			if (previous && current.products_id != previous.products_id) {
				this.getGamesFPS();
			}
		}
	},
	created() {
		window.fansOrder = [];
	},
	mounted() {
		this.configureValidationMessages();

		$("#share-mail").on("hidden.bs.modal", () => {
			this.email = "";
			this.emailSent = false;
			this.$validator.reset();
		});
	},
	methods: {
		...mapActions([
			"changeSessionGamesData",
			"changeShowLoadingOverlay"
		]),
		addDiscordNitro() {
			axios({
				url: `/update-part/1/1?pid=303&validate=true&step4=true`,
				headers: {
					"token": CONFIG.SESSION
				}
			});
		},
		configureValidationMessages() {
			const dictionary = {
				en: {
					custom: {
						share_email: {
							email: "You did not enter in a valid email address. Please try again.",
							required: "You must enter in an email address."
						}
					}
				}
			};

			Validator.localize(dictionary);
		},
		copyToClipboard(element) {
			const $temp = $("<input>");
			$("body").append($temp);
			$temp.val($(element).text()).select();
			document.execCommand("copy");
			$temp.remove();
		},
		getGamesFPS() {
			const cpuId = this.activeBuild.cpu.products_id;
			const gpuId = this.activeBuild.gpu.products_id;
			const resolution = this.sessionData.resolutionText == "1920x1080" ? "1080" : "1440";
			axios({
				url: `/games-fps?cpu=${cpuId}&gpu=${gpuId}&resolution=${resolution}`,
				method: "GET",
				headers: {
					token: CONFIG.SESSION
				}
			}).then(response => {
				const gamesInfo = response.data;
				const sessionGames = _.cloneDeep(this.games);
				for (let i = 0; i < sessionGames.length; i++) {
					sessionGames[i].game_value = gamesInfo[sessionGames[i].games_id] || 0;
				}
				this.changeSessionGamesData(sessionGames);
			});
		},
		hideLoading() {
			this.changeShowLoadingOverlay(false);
		},
		async sendBuildToEmail() {
			const isValid = await this.$validator.validateAll();

			if (!isValid) {
				return;
			}

			this.emailSent = true;

			const bodyFormData = new FormData();
			bodyFormData.append("email", this.email);
			axios({
				url: `/vr-draft/${this.draftId}/email`,
				method: "POST",
				data: bodyFormData
			}).then(response => {
				toastr.success(response.data[0]);
			}).catch(error => {
				toastr.error(error, "Error");
			}).then();
		},
		setLocalStorageVuex() {
			window.localStorage.setItem("vuex-build", JSON.stringify(this.activeBuild));
		},
		showLoading() {
			this.changeShowLoadingOverlay(true);
		},
		updateBuildInDatabase() {
			axios({
				url: `/users/0/letsbld-drafts/${this.draftId}?session=${window.CONFIG.SESSION}`,
				method: "PUT"
			});
		}
	}
};
</script>

<style lang="scss" scoped>
    footer {
        display: block !important;
    }
</style>>
